import {type ReactNode} from 'react'
import {findFirstTextChild} from '~/utils/findFirstTextChild'

type MarkRuleProps = {
  children: ReactNode
  key: string
}

export const handleDropCapMark = ({children, key}: MarkRuleProps) => {
  // Drop cap fragment should be limited to first item in nested children array
  const plainText = findFirstTextChild(children) || ''
  // In order to ensure cross-browser consistency & best accessible experience, we need to render the first letter/ word in dropcap as separate spans.
  // See more here: https://css-tricks.com/snippets/css/drop-caps
  const [firstWord, ...rest] = plainText?.split(' ')

  return (
    <span className="wysiwyg-dropcap uppercase" key={key}>
      <span aria-hidden="true">
        <span className="float-left me-s1 mt-[0.08em] text-[4.36rem] leading-[1] before:-mt-[0.2em] before:block after:-mb-[0.28em] after:block md:text-[4.95rem] lg:text-[5.6rem]">
          {firstWord.charAt(0)}
        </span>
        {firstWord.substring(1)}
      </span>
      <span className="sr-only">{firstWord}</span>
      {` ${rest.join(' ')}`}
    </span>
  )
}
